<template>
  <div class="d-flex" :class="this.$store.state.menuToggle" id="wrapper">
    <TheSidemenu />
    <div id="page-content-wrapper">
      <TheTopmenu />
      <div class="container-fluid text-start">
        <p class="fs-5 m-2">
          {{ this.$route.meta.title }}
        </p>
        <div v-if="!productsList">
          <i class="fas fa-spinner fa-spin fs-1 mt-3"></i>
        </div>
        <div v-else class="row g-4">
          <CartAlert />
          <div
            v-for="item in productsList"
            :key="item.id"
            class="col-lg-3 col-md-3 col-sm-4 col-6 mt-3"
          >
            <div class="card p-2">
              <router-link
                :to="{
                  name: 'Products',
                  params: {
                    productId: item.id,
                    buyed_before: item.buyed_before ? 1 : 0,
                  },
                }"
                class="d-block text-decoration-none text-center"
              >
                <img
                  v-lazy="{
                    src: API_STORAGE_URL + item.main_image_thumb_path,
                    loading: API_STORAGE_URL + 'storage/animated-book.gif',
                    error: noPicAddr,
                  }"
                  class="img-fluid rounded-top w-100"
                />
                <div class="bg-white p-0">
                  <div class="mt-0 text-dark fw-bold text-center pt-2">
                    {{ item.name }}
                  </div>
                  <div
                    class="mt-2 text-dark d-flex justify-content-between p-2"
                  >
                    <div v-if="item.sale_price == item.price">
                      قیمت: <br />
                      <span class="fw-bold">
                        {{ this.utils.monize(item.price) }}
                        تومان
                      </span>
                      <br />
                      <span>&nbsp;</span>
                    </div>
                    <div v-else>
                      قیمت پیشنهاد ویژه: <br />
                      <span
                        class="text-danger text-decoration-line-through fw-bold"
                      >
                        {{ this.utils.monize(item.price) }}
                      </span>
                      <br />
                      <span class="text-success fw-bold">
                        {{ this.utils.monize(item.sale_price) }}
                        تومان
                      </span>
                    </div>

                    <div>
                      <a class="text-decoration-none d-block">
                        بیشتر
                        <i class="fas fa-arrow-left"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </router-link>
              <template v-if="item.type === 'chairs'">
                <FadeInOut entry="left" exit="center" :duration="800" appear>
                  <div>
                    <router-link
                      :to="{
                        name: 'Products',
                        params: { productId: item.id, buyed_before: 0 },
                      }"
                      class="btn btn-primary d-block"
                    >
                      <i class="fas fa-chair"></i>
                      انتخاب صندلی
                    </router-link>
                  </div>
                </FadeInOut>
              </template>
              <template v-else-if="item.type === 'package'">
                <FadeInOut entry="left" exit="center" :duration="800" appear>
                  <div>
                    <router-link
                      :to="{
                        name: 'Products',
                        params: { productId: item.id, buyed_before: 0 },
                      }"
                      class="btn btn-primary d-block"
                    >
                      <i class="fas fa-info-circle"></i>
                      جزئیات
                    </router-link>
                  </div>
                </FadeInOut>
              </template>
              <template v-else>
                <FadeInOut
                  v-if="!item.buyed_before"
                  entry="left"
                  exit="center"
                  :duration="800"
                  appear
                >
                  <div v-if="item.sale_price == 0">
                    <router-link
                      :to="{
                        name: 'Products',
                        params: { productId: item.id, buyed_before: 1 },
                      }"
                      class="btn btn-success d-block"
                    >
                      دوره رایگان - مشاهده
                    </router-link>
                  </div>
                  <div v-else>
                    <a
                      class="btn btn-primary d-block"
                      @click="addToCart(item.id)"
                    >
                      <i class="fas fa-shopping-cart"></i>
                      افزودن به سبد خرید
                      <i
                        :id="`progress-${item.id}`"
                        class="fas fa-spinner fa-spin d-none"
                      ></i>
                      <i
                        :id="`check-${item.id}`"
                        class="fas fa-check d-none"
                      ></i>
                    </a>
                  </div>
                </FadeInOut>
                <div v-else entry="left" exit="center" :duration="800" appear>
                  <div>
                    <router-link
                      :to="{
                        name: 'Products',
                        params: {
                          productId: item.id,
                          buyed_before: item.buyed_before ? 1 : 0,
                        },
                      }"
                      class="btn btn-secondary d-block"
                    >
                      قبلا خریداری شده - مشاهده
                    </router-link>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import TheSidemenu from "../../components/TheSidemenu";
import TheTopmenu from "../../components/TheTopmenu";
import ArefApi from "../../libs/api.js";
import utils from "../../libs/utils";
import { FadeInOut } from "vue3-transitions";
import CartAlert from "./CartAlert.vue";

export default {
  name: "Shop",
  created() {
    this.arefApi = new ArefApi(this);
    this.utils = new utils();
    this.getUserProducts();
    this.noPicAddr =
      process.env.VUE_APP_API_STORAGE_URL + process.env.VUE_APP_NO_IMAGE_URL;
  },
  components: {
    TheSidemenu,
    TheTopmenu,
    FadeInOut,
    CartAlert,
  },
  data() {
    return {
      categoryOneId: this.$route.params.categoryOneId
        ? this.$route.params.categoryOneId
        : null,
      productsList: null,
      API_STORAGE_URL: process.env.VUE_APP_API_STORAGE_URL,
      cartAmount: 0,
      cartCount: this.$store.state.cartCount,
      showCartMsg: true,
    };
  },
  methods: {
    getUserProducts() {
      this.arefApi
        .getUserCategoryOneProducts(this.categoryOneId)
        .then((resp) => {
          this.productsList = resp.data;
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
    addToCart(products_id) {
      const obj = {
        products_id: products_id,
      };
      document
        .querySelector(`#progress-${products_id}`)
        .classList.remove(`d-none`);
      this.arefApi
        .addProductToCart(obj)
        .then((resp) => {
          document
            .querySelector(`#progress-${products_id}`)
            .classList.add(`d-none`);
          document
            .querySelector(`#check-${products_id}`)
            .classList.remove(`d-none`);
          this.$store.commit("set", [
            "cartCount",
            this.utils.getCartCount(resp.data),
          ]);

          this.$store.commit("set", ["cartAmount", resp.data.amount]);
          window.scrollTo(0, top);
        })
        .catch((err) => {
          this.utils.showErrors(this, err);
        });
    },
  },
};
</script>